import React, { useEffect, useState } from 'react';
import inspectionStorage from '../services/inspectionStorage';

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #ecfdf3, #d1fae5)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '16px'
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#065f46',
    marginBottom: '8px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    marginBottom: '10px'
  },
  textarea: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    minHeight: '120px',
    resize: 'vertical',
    marginBottom: '10px'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px'
  },
  phraseList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  phraseItem: {
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start',
    padding: '10px 12px',
    borderRadius: '10px',
    border: '2px solid #e5e7eb',
    background: '#f9fafb',
    fontSize: '13px',
    lineHeight: 1.35
  },
  phraseCheckbox: {
    marginTop: '2px'
  },
  helperRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '8px'
  },
  smallButton: {
    background: '#eef2ff',
    color: '#3730a3',
    border: '1px solid #c7d2fe',
    borderRadius: '8px',
    padding: '6px 10px',
    fontSize: '12px',
    cursor: 'pointer',
    fontWeight: '600'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

const PHRASES_TYPES = [
  "Au vu des éléments contrôlés de l'installation électrique tel défini dans le tableau récapitulatif des équipements examinés et compte tenu de leurs conditions et de sollicitations au moment du contrôle, le risque de départ de feu est faible, en l'absence d'anomalie.",
  "L'installation est correctement maintenue et entretenue",
  "Bien que correctement entretenue (maintenance régulière), l'installation électrique présente des échauffements.",
  "Au vu de la possibilité d'évolution rapide d'un défaut d'échauffement, il est indispensable d'apporter les actions correctives préconisées",
  "Bien que correctement entretenue, l'installation électrique présente des échauffements particulièrement inquiétants (priorité 1)",
  "Au vu de la possibilité d'évolution rapide des anomalies constatées, il est indispensable d'apporter immédiatement les actions correctives nécessaires.",
  "Compte tenu du caractère névralgique de l'équipement xxxx, il serait judicieux d'étendre, en priorité, les vérifications par thermographie pour ces matériels qui ne figurent pas sur la liste des équipements à contrôler",
  "Locaux encombrés par des matériels dangereux"
];

export default function Etape4ConclusionThermoMobile({ mission, onBack, onSave }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [q19, setQ19] = useState({
    phrases_types_selected: [],
    conclusion_structured: {
      selectedPhrases: []
    },
    improvements_proposed: '',
    signature_location: '',
    signature_date: '',
    accompanied_by_name: '',
    accompanied_by_function: '',
    accompanied_by_company: '',
    observations_communicated_to_name: '',
    observations_communicated_to_function: '',
    observations_communicated_to_company: ''
  });

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const getDefaultSignatureLocation = () => (
    mission?.etablissement_ville ||
    mission?.ville_etablissement ||
    mission?.client_ville ||
    mission?.ville_client ||
    ''
  );

  const getDefaultSignatureDate = () => (
    mission?.date_intervention ||
    mission?.date_verification ||
    mission?.date_affectation ||
    ''
  );

  const applyAutoFill = (data) => {
    const next = { ...data };
    if (!next.signature_location) {
      next.signature_location = getDefaultSignatureLocation();
    }
    if (!next.signature_date) {
      next.signature_date = getDefaultSignatureDate();
    }
    if (!Array.isArray(next.phrases_types_selected)) {
      next.phrases_types_selected = [];
    }
    const structuredPhrases = Array.isArray(next.conclusion_structured?.selectedPhrases)
      ? next.conclusion_structured.selectedPhrases
      : [];
    if (next.phrases_types_selected.length === 0 && structuredPhrases.length > 0) {
      next.phrases_types_selected = [...structuredPhrases];
    }
    next.conclusion_structured = {
      ...(next.conclusion_structured || {}),
      selectedPhrases: next.phrases_types_selected
    };
    return next;
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
      const base = stored || {};
      setQ19((prev) => applyAutoFill({ ...prev, ...base }));
    } catch (error) {
      console.error('❌ Erreur chargement conclusion:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateField = (field, value) => {
    setQ19(prev => ({ ...prev, [field]: value }));
  };

  const togglePhrase = (phrase) => {
    setQ19((prev) => {
      const current = Array.isArray(prev.phrases_types_selected) ? prev.phrases_types_selected : [];
      const exists = current.includes(phrase);
      const nextSelected = exists
        ? current.filter((item) => item !== phrase)
        : [...current, phrase];
      return {
        ...prev,
        phrases_types_selected: nextSelected,
        conclusion_structured: {
          ...(prev.conclusion_structured || {}),
          selectedPhrases: nextSelected
        }
      };
    });
  };

  const copyAccompaniedToObservations = () => {
    setQ19((prev) => ({
      ...prev,
      observations_communicated_to_name: prev.accompanied_by_name || '',
      observations_communicated_to_function: prev.accompanied_by_function || '',
      observations_communicated_to_company: prev.accompanied_by_company || ''
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
      const merged = { ...(stored || {}), ...q19 };
      await inspectionStorage.saveStep(mission.id, 'rapport_q19_data', merged);
      if (onSave) onSave(q19);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#ecfdf3' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#10b981', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#065f46', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Conclusion</h1>
        <button style={styles.backBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.cardTitle}>✅ Phrases types</div>
          <div style={styles.phraseList}>
            {PHRASES_TYPES.map((phrase) => (
              <label key={phrase} style={styles.phraseItem}>
                <input
                  type="checkbox"
                  style={styles.phraseCheckbox}
                  checked={q19.phrases_types_selected?.includes(phrase)}
                  onChange={() => togglePhrase(phrase)}
                />
                <span>{phrase}</span>
              </label>
            ))}
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>📝 Commentaires personnalisés</div>
          <textarea
            style={styles.textarea}
            value={q19.improvements_proposed || ''}
            onChange={(e) => updateField('improvements_proposed', e.target.value)}
            placeholder="Synthèse des anomalies et recommandations..."
          />
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>✍️ Signature</div>
          <div style={styles.row}>
            <div>
              <label style={styles.label}>Lieu</label>
              <input style={styles.input} value={q19.signature_location || ''} onChange={(e) => updateField('signature_location', e.target.value)} />
            </div>
            <div>
              <label style={styles.label}>Date</label>
              <input type="date" style={styles.input} value={q19.signature_date || ''} onChange={(e) => updateField('signature_date', e.target.value)} />
            </div>
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>👤 Personne accompagnante</div>
          <input style={styles.input} placeholder="Nom" value={q19.accompanied_by_name || ''} onChange={(e) => updateField('accompanied_by_name', e.target.value)} />
          <input style={styles.input} placeholder="Fonction" value={q19.accompanied_by_function || ''} onChange={(e) => updateField('accompanied_by_function', e.target.value)} />
          <input style={styles.input} placeholder="Société" value={q19.accompanied_by_company || ''} onChange={(e) => updateField('accompanied_by_company', e.target.value)} />
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>📣 Observations communiquées à</div>
          <div style={styles.helperRow}>
            <button style={styles.smallButton} onClick={copyAccompaniedToObservations} type="button">
              Copier depuis la personne accompagnante
            </button>
          </div>
          <input style={styles.input} placeholder="Nom" value={q19.observations_communicated_to_name || ''} onChange={(e) => updateField('observations_communicated_to_name', e.target.value)} />
          <input style={styles.input} placeholder="Fonction" value={q19.observations_communicated_to_function || ''} onChange={(e) => updateField('observations_communicated_to_function', e.target.value)} />
          <input style={styles.input} placeholder="Société" value={q19.observations_communicated_to_company || ''} onChange={(e) => updateField('observations_communicated_to_company', e.target.value)} />
        </div>
      </div>

      <div style={styles.saveSection}>
        <button style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }} onClick={handleSave} disabled={saving}>
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}
